import { TDraftRoutes, TNavOption } from '@/types';

export const baseUrl = process.env.NEXT_PUBLIC_BASE_URL || '';

export const months = [
  { value: 0, label: 'January' },
  { value: 1, label: 'February' },
  { value: 2, label: 'March' },
  { value: 3, label: 'April' },
  { value: 4, label: 'May' },
  { value: 5, label: 'June' },
  { value: 6, label: 'July' },
  { value: 7, label: 'August' },
  { value: 8, label: 'September' },
  { value: 9, label: 'October' },
  { value: 10, label: 'November' },
  { value: 11, label: 'December' },
];

// change values to their url values -> 10, 20, 50, 51
export const numVisitors = [
  { value: 1, label: 'Private tour' },
  { value: 2, label: 'Up to 10' },
  { value: 3, label: 'Up to 20' },
  { value: 4, label: 'Up to 50' },
  { value: 5, label: '50+' },
];

export const languages = [
  { label: 'English', value: 1 },
  { label: 'Spanish', value: 2 },
];

export const DRAFT_ROUTES: Record<TDraftRoutes, TDraftRoutes> = {
  activity: 'activity',
  about: 'about',
  photos: 'photos',
};

export const draftTabs: Array<TNavOption> = [
  { value: 1, label: 'Activity type', pathname: '/activity' },
  { value: 2, label: 'About this tour', pathname: '/about' },
  { value: 3, label: 'Photos', pathname: '/photos' },
  { value: 4, label: 'Location', pathname: '/location' },
  { value: 5, label: 'Availability', pathname: '/availability' },
  { value: 6, label: 'Languages', pathname: '/languages' },
  { value: 7, label: "What's included", pathname: '/whats-included' },
  { value: 8, label: 'Animals to see', pathname: '/animals-to-see' },
  { value: 9, label: 'Visitors & Pricing', pathname: '/visitors-and-pricing' },
  { value: 10, label: 'Commissions', pathname: '/commissions' },
  { value: 11, label: 'Tour preview', pathname: '/preview' },
];

export const daysOfWeek = [
  { value: 0, label: 'Monday' },
  { value: 1, label: 'Tuesday' },
  { value: 2, label: 'Wednesday' },
  { value: 3, label: 'Thursday' },
  { value: 4, label: 'Friday' },
  { value: 5, label: 'Saturday' },
  { value: 6, label: 'Sunday' },
];

export const TIME_PERIOD_OPTIONS = [
  { label: 'AM', value: 'AM' },
  { label: 'PM', value: 'PM' },
];

export const TIME_TYPE_OPTIONS = [
  { label: 'Minutes', value: 'Minutes' },
  { label: 'Hours', value: 'Hours' },
  { label: 'Days', value: 'Days' },
];
